export default __webpack_public_path__ + "static/media/gallery_01.1b63c484.jpg";